import Header from '../Layout/Header';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import "./css/ManageReview.css";
import { dataUser } from '../../../src/Component/Helpers/util';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Layout/Sidebar';
import { Layout } from "antd";
import CustomHeader from '../Layout/Header';
import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect';
import SwButton from '../Common/SwButtons/SwButtons';
import SwModal from '../Common/SwModal/SwModal';
import AntDTable from '../Common/AntDTable/AntDTable';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function MonthlyReview() {
    const [location, setLocation] = useState([{ value: '', label: 'Select' }]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [inactiveUsers, setInactiveUsers] = useState([]);
    const [selectedLocationIds, setSelectedLocationIds] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [editRecId, setEditRecId] = useState();
    const [showRevokeModal, setShowRevokeModal] = useState(false);
    const LocationData = [];
    const reviewedIdsData = localStorage.getItem('reviewdLocIds');
    const arrayReviewedData = JSON.parse("[" + reviewedIdsData + "]");




    const [collapsed, setCollapsed] = useState(true);
    const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
    };

    location.map(item => {
        if (arrayReviewedData && arrayReviewedData.length > 0) {
            if (item.rec_id && !arrayReviewedData.includes(item.rec_id)) {
                LocationData.push({ value: item?.rec_id, label: item.location_name })
            }
        }
        else {
            LocationData.push({ value: item?.rec_id, label: item.location_name })
        }
    }
    );
    let navigate = useNavigate();

    function onLocationChange(locations) {
        let selectedLocation = [];
        locations.map(l => {
            selectedLocation.push(l.value.toString());
        });
        setSelectedLocations(locations);
        setSelectedLocationIds(selectedLocation);
    }


    useEffect(() => {
        let authToken = JSON.parse(localStorage.getItem('headData'))

        const params = {
            params: { spoc: UserObj.rec_id, client: UserObj.company_id },
            headers: {
                Authorization: authToken?.spintlyToken,
            }
        };
        axios
            .get(
                `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
                params,
            )
            .then(res => {
                if (res.data.status == 'success') {
                    setLocation(res.data.data);
                }
            });
    }, []);


    const getInactiveUsers = () => {
        let authToken = JSON.parse(localStorage.getItem('headData'))
        const params = {
            company_id: UserObj.company_id,
            userid: UserObj.rec_id,
            location: selectedLocationIds
        };
        if (selectedLocationIds.length > 0) {
            axios
                .post(
                    `${process.env.REACT_APP_API_URL}userReview/get-inactive-user`,
                    params,
                    {
                        headers: {
                            Authorization: authToken?.spintlyToken,
                        }
                    }
                )
                .then(res => {
                    if (res.data.status == 'success') {
                        setInactiveUsers(res.data.data);
                    }
                    // else {
                    //     toast.configure();
                    //     toast.error(res.data.message, {
                    //         
                    //     });
                    // }
                });
        }
        else {
            setInactiveUsers([]);
        }

    }

    useEffect(() => {
        getInactiveUsers();
    }, [selectedLocations]);

    useEffect(() => {
        setTimeout(() => setSpinner(false), 1000);
    }, []);

    var labels = selectedLocations.map(obj => obj.label)

    const denyAccess = () => {
        let authToken = JSON.parse(localStorage.getItem('headData'))
        const param = {
            isAllowedAccess: '2',
            rec_id: editRecId.rec_id,
            user_rec_id: UserObj.rec_id,
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}user/access_details`, param, {
                headers: {

                    Authorization: authToken?.spintlyToken,

                },
            }).then(response => {
                if (response.data.status == 200) {
                    toast.configure();
                    toast.success(response.data.status_message, {

                    });
                    setTimeout(() => {
                        getInactiveUsers();
                    }, 1000)
                }
                else {
                    toast.configure();
                    toast.error(response.data.status_message, {

                    });
                }
            })
    }



    function handleClick() {
        localStorage.setItem('exitReview', false);
        localStorage.setItem('selectedLocationReview', JSON.stringify(selectedLocations));
        navigate({
            pathname: '/ActiveMember',
            // state: selectedLocations
        });
        window.location.reload();
    }

    return (
        <>
            <Layout>

                <Sidebar collapsed={collapsed} />

                <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />


                <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
                    <SwModal
                        show={showRevokeModal}
                        onClose={() => setShowRevokeModal(false)}
                        size="sm"
                        className="sw-small-modal"
                        footer={
                            <div className="d-flex justify-content-center gap-3">
                                <SwButton variant="dark-outline" onClick={() => setShowRevokeModal(false)} size="sm">Cancel</SwButton>
                                <SwButton variant="dark" size="sm" onClick={() => { denyAccess(editRecId.rec_id); setShowRevokeModal(false); }}>Confirm</SwButton>
                            </div>
                        }
                    >
                        <SwButton variant="" className='btn-close btn-close-custom' onClick={() => setShowRevokeModal(false)}></SwButton>

                        <h3 className='SwModalSubHeading'>Confirm Revoke Access</h3>
                        <p className="mb-1"><strong>{editRecId && editRecId.name}</strong> status will be changed to <strong>No access</strong></p>
                        <span className="SwTextDanger SwTextSmall">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <mask id="mask0_201_4573" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                                    <rect width="16" height="16" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_201_4573)">
                                    <path d="M8.00065 11.3333C8.18954 11.3333 8.34798 11.2693 8.47598 11.1413C8.60354 11.0137 8.66732 10.8555 8.66732 10.6666C8.66732 10.4777 8.60354 10.3193 8.47598 10.1913C8.34798 10.0637 8.18954 9.99992 8.00065 9.99992C7.81176 9.99992 7.65354 10.0637 7.52598 10.1913C7.39798 10.3193 7.33398 10.4777 7.33398 10.6666C7.33398 10.8555 7.39798 11.0137 7.52598 11.1413C7.65354 11.2693 7.81176 11.3333 8.00065 11.3333ZM7.33398 8.66658H8.66732V4.66658H7.33398V8.66658ZM8.00065 14.6666C7.07843 14.6666 6.21176 14.4915 5.40065 14.1413C4.58954 13.7915 3.88398 13.3166 3.28398 12.7166C2.68398 12.1166 2.2091 11.411 1.85932 10.5999C1.5091 9.78881 1.33398 8.92214 1.33398 7.99992C1.33398 7.0777 1.5091 6.21103 1.85932 5.39992C2.2091 4.58881 2.68398 3.88325 3.28398 3.28325C3.88398 2.68325 4.58954 2.20814 5.40065 1.85792C6.21176 1.50814 7.07843 1.33325 8.00065 1.33325C8.92287 1.33325 9.78954 1.50814 10.6006 1.85792C11.4118 2.20814 12.1173 2.68325 12.7173 3.28325C13.3173 3.88325 13.7922 4.58881 14.142 5.39992C14.4922 6.21103 14.6673 7.0777 14.6673 7.99992C14.6673 8.92214 14.4922 9.78881 14.142 10.5999C13.7922 11.411 13.3173 12.1166 12.7173 12.7166C12.1173 13.3166 11.4118 13.7915 10.6006 14.1413C9.78954 14.4915 8.92287 14.6666 8.00065 14.6666ZM8.00065 13.3333C9.48954 13.3333 10.7507 12.8166 11.784 11.7833C12.8173 10.7499 13.334 9.48881 13.334 7.99992C13.334 6.51103 12.8173 5.24992 11.784 4.21658C10.7507 3.18325 9.48954 2.66659 8.00065 2.66659C6.51176 2.66659 5.25065 3.18325 4.21732 4.21658C3.18398 5.24992 2.66732 6.51103 2.66732 7.99992C2.66732 9.48881 3.18398 10.7499 4.21732 11.7833C5.25065 12.8166 6.51176 13.3333 8.00065 13.3333Z" fill="#FF0606" />
                                </g>
                            </svg>
                            <span className="SwTextDanger SwTextSmall">The user will not be able to access the Smartworks mobile app</span>
                        </span>
                    </SwModal>

                    <div className="SwHeading">
                        <h2>Review Inactive Members</h2>
                        {/* <p>
                            This data shows the people who are not active on the app for the last 15 days of the previous month
                        </p> */}
                        <div className="col-md-12 SwTextSmall mb-3">
                            <div className=" d-inline-flex">
                                <i class="bi bi-info-circle-fill" />
                                <span className='ms-1'>
                                    This data shows the people who are not active on the app for the last 15 days of the previous month
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 col-xl-4 col-lg-8">
                        <div className="SwFormGroup">
                            <label className='SwFormLabel'>Locations</label>
                            <SwMultiSelect
                                options={LocationData}
                                value={selectedLocations}
                                onChange={onLocationChange}
                                placeholder="Select Location"
                                labelledBy="Seat Number"
                            />
                        </div>
                        {selectedLocations == '' ? (
                            <span className='SwTextDanger SwTextSmall'>
                                Please select location first **{' '}
                            </span>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="location_badges mb-3">
                        {labels.map((label) => (
                            <span>{label}</span>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <AntDTable
                                size="small"
                                columns={[
                                    {
                                        title: "Name",
                                        dataIndex: "name",
                                        key: "name",
                                    },
                                    {
                                        title: "Corporate Email",
                                        dataIndex: "email",
                                        key: "email",
                                    },
                                    {
                                        title: "Phone",
                                        dataIndex: "phone",
                                        key: "phone",
                                    },
                                    {
                                        title: "Base Location",
                                        dataIndex: "business_name",
                                        nowrap: true,
                                        key: "business_name",
                                    },
                                    {
                                        title: "Last Active On App",
                                        dataIndex: "timestamp",
                                        minWidth: 150,
                                        key: "timestamp",
                                        render: (timestamp) =>
                                            timestamp == null ? "-" : moment.unix(timestamp).format("YYYY-MM-DD HH:mm:ss"),
                                    },
                                    {
                                        title: "Status",
                                        dataIndex: "isSpocApproved",
                                        key: "isSpocApproved",
                                        minWidth: 120,
                                        render: (isSpocApproved) =>
                                            isSpocApproved == 1 ? (
                                                <div className="text-success">Has Access</div>
                                            ) : (
                                                <div className="text-danger">No Access</div>
                                            ),
                                    },
                                    {
                                        title: "Action",
                                        key: "action",
                                        minWidth: 150,
                                        render: (_, record) => (
                                            <SwButton
                                                variant="dark-outline"
                                                size="sm"
                                                onClick={() => { setEditRecId(record); setShowRevokeModal(true); }}
                                            >
                                                Revoke access
                                            </SwButton>
                                        ),
                                    },
                                ]}
                                dataSource={inactiveUsers}
                                rowKey="rec_id"
                                loading={spinner}
                                pagination={false}
                            />
                            {selectedLocations.length <= 0 ?
                                <div className="py-3"><SwButton variant="primary" disabled onClick={handleClick}
                                    icon={<i className="bi bi-arrow-right-circle"></i>}
                                    iconPosition='end'
                                >Proceed</SwButton></div>
                                : <div className="py-3"><SwButton variant="primary" onClick={handleClick}
                                    icon={<i className="bi bi-arrow-right-circle"></i>}
                                    iconPosition='end'
                                >Proceed</SwButton></div>
                            }
                        </div>
                    </div>

                </Layout>

            </Layout >
        </>
    );
}
export default connect(
)(MonthlyReview);


